import { render, staticRenderFns } from "./AddVideoLink.vue?vue&type=template&id=43decf91&"
import script from "./AddVideoLink.vue?vue&type=script&lang=js&"
export * from "./AddVideoLink.vue?vue&type=script&lang=js&"
import style0 from "./AddVideoLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports